import { GetParticipantForDashboardQuery as GetParticipantForDashboard } from '__generated__/graphql';
import useBaseProject from '../common/useProject';

export type Project = GetParticipantForDashboard['project'];

const useProject = () => useBaseProject() as Project;

export default useProject;
